exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agent-modal-body {\n  background-color: #f2f4f8 !important; }\n\n.activity-box-w {\n  cursor: pointer; }\n  .activity-box-w:hover .activity-box {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: 0px 5px 12px rgba(126, 142, 177, 0.2); }\n  .activity-box-w:hover .activity-box:before {\n    transform: translateY(-1.5px) translateX(9.5px) scale(1); }\n", ""]);

// exports
